import React from "react";
var __jsx = React.createElement;
import CustomLogo from '@anm/components/video-landings/CustomLogo';
import LandingCTA from '@anm/components/video-landings/LandingCTA';
import { DEFAULT_WAVE_COLOR } from '@anm/constants/colors';
import sanitizeText from '@anm/helpers/string/sanitizeText';
import showdown from 'showdown';
import { CTAWrapper, LandingMetaWrapper, LandingTitle, LogoWrapper, Wrapper } from './Wrapper';
export { Wrapper, LandingTitle, LandingMetaWrapper };

var DataWrapper = function DataWrapper(_ref) {
  var cta = _ref.cta,
      meta = _ref.meta,
      _ref$isCTA = _ref.isCTA,
      isCTA = _ref$isCTA === void 0 ? true : _ref$isCTA,
      videoId = _ref.videoId,
      fontStyles = _ref.fontStyles,
      logoUrl = _ref.logoUrl,
      maxWidth = _ref.maxWidth,
      _ref$colorTheme = _ref.colorTheme,
      colorTheme = _ref$colorTheme === void 0 ? 'pure' : _ref$colorTheme,
      CTAFontStyles = _ref.CTAFontStyles,
      landingCTARef = _ref.landingCTARef,
      dataWrapperRef = _ref.dataWrapperRef,
      landingMetaRef = _ref.landingMetaRef,
      _ref$layoutVariant = _ref.layoutVariant,
      layoutVariant = _ref$layoutVariant === void 0 ? 't1' : _ref$layoutVariant,
      _ref$layoutDirection = _ref.layoutDirection,
      layoutDirection = _ref$layoutDirection === void 0 ? 'column' : _ref$layoutDirection,
      _ref$playerColor = _ref.playerColor,
      playerColor = _ref$playerColor === void 0 ? DEFAULT_WAVE_COLOR : _ref$playerColor;
  var isMetaExists = !!(meta !== null && meta !== void 0 && meta.heading || meta !== null && meta !== void 0 && meta.bodyText);
  var isDataExists = isMetaExists || isCTA;
  var converter = new showdown.Converter();
  var markedBodyText = meta !== null && meta !== void 0 && meta.bodyText ? converter.makeHtml(meta.bodyText) : '';
  return __jsx(Wrapper, {
    ref: dataWrapperRef,
    isNoMeta: !isMetaExists,
    layoutDirection: layoutDirection,
    maxWidth: maxWidth,
    layoutVariant: layoutVariant
  }, logoUrl && __jsx(LogoWrapper, null, __jsx(CustomLogo, {
    logoUrl: logoUrl,
    alt: (meta === null || meta === void 0 ? void 0 : meta.heading) || logoUrl
  })), isDataExists && __jsx(LandingMetaWrapper, {
    fontStyles: fontStyles,
    colorTheme: colorTheme,
    playerColor: playerColor,
    ref: landingMetaRef
  }, isMetaExists && __jsx(LandingTitle, {
    title: sanitizeText(meta === null || meta === void 0 ? void 0 : meta.heading),
    description: markedBodyText,
    className: "title_block"
  }), isCTA && __jsx(CTAWrapper, {
    className: "cta_wrapper"
    /* TODO: investigate SC issue about className changes */

  }, __jsx(LandingCTA, {
    cta: cta,
    playerColor: playerColor,
    theme: colorTheme,
    projectId: videoId,
    CTAref: landingCTARef,
    fontStyles: CTAFontStyles
  }))));
};

export default DataWrapper;